export const UPDATE_CONFIG = 'UPDATE_CONFIG';

export const updateConfig = (data: any) => ({
  type: UPDATE_CONFIG,
  payload: data,
});